import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { WorkForm } from './../forms'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class WorkNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Ажил',
            key: shortid.generate(),
            categories: []
        }
    }

    componentDidMount = () => {
        this.fetchCategories()
    }

    fetchCategories = async () => {
        try {
            const { data } = await axios.get('/categories', {
                progress: true,
                params: {
                    rowsPerPage: -1,
                    sortBy: 'name',
                    sortOrder: 'asc'
                }
            })

            this.setState({
                key: shortid.generate(),
                categories: data
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            key,
            title,
            categories
        } = this.state
        return (
            <Dashboard title={title}>
                <WorkForm 
                    key={key}
                    categories={categories}
                    path="works"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(WorkNew)
